import { useEffect, useRef, type ReactNode } from 'react';
import type { T } from '../i18n.tsx';

const PATHS = {
  dashboard: 'M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-4H4zM14 4v4h6V4z',
  clients: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21a7 7 0 0 1 14 0M16 3.5a4 4 0 0 1 0 7.5M18 14a6 6 0 0 1 4 7',
  chats: 'M4 5h12v9H8l-4 3.5zM8 17.5V18h8l4 3v-9h-2',
  orders: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6',
  providers: 'M14.7 6.3a4 4 0 0 0-5.4 5.3L3 18l3 3 6.4-6.3a4 4 0 0 0 5.3-5.4l-2.5 2.5-2.8-.7-.7-2.8z',
  agencies: 'M3 21V8l9-5 9 5v13M9 21v-6h6v6M3 21h18',
  venues: 'M5 11v10h14V11M3 7l2-4h14l2 4v1a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0zM10 21v-5h4v5',
  crm: 'M3 4h18l-7 8.5V19l-4 2v-8.5z',
  products: 'M12 3l8 4.5v9L12 21l-8-4.5v-9zM4 7.5l8 4.5 8-4.5M12 12v9',
  journal: 'M6 3h11a2 2 0 0 1 2 2v16H8a2 2 0 0 1-2-2zM6 19a2 2 0 0 1 2-2h11M10 8h5M10 12h5',
  team: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 21a7 7 0 0 1 14 0',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4',
  back: 'M19 12H5M11 18l-6-6 6-6',
  plus: 'M12 5v14M5 12h14',
  gift: 'M4 8h16v4H4zM5 12h14v8H5zM12 8v12M12 8c-2-3-6-3-6 0M12 8c2-3 6-3 6 0',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  send: 'M4 12l16-8-6 16-2.5-6.5z',
  check: 'M5 12l4 4 10-10',
  close: 'M6 6l12 12M18 6L6 18',
  filter: 'M4 6h16M7 12h10M10 18h4',
  telegram: 'M21 4L3 11l6 2 2 6 3-4 5 4z M9 13l8-6',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowDown: 'M12 5v14M6 13l6 6 6-6',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  clip: 'M20 11.5l-8.2 8.2a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.5 8.5a1.7 1.7 0 0 1-2.4-2.4l7.8-7.8',
  bolt: 'M13 3L5 13.5h6L10 21l8-10.5h-6z',
  lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  file: 'M7 3h7l5 5v13H7zM14 3v5h5',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 7.5v.01',
  swap: 'M4 8h14l-3.5-3.5M20 16H6l3.5 3.5',
  userPlus: 'M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM3 21a7 7 0 0 1 12-4.9M19 14v6M16 17h6',
  archive: 'M4 5h16v4H4zM5 9v10h14V9M10 13h4',
  bot: 'M6 9h12v10H6zM12 5v4M9.5 13.5v.01M14.5 13.5v.01M9 17h6M3 13v2M21 13v2',
  warn: 'M12 3l10 18H2zM12 10v5M12 18v.01',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z',
} as const;
export type IconName = keyof typeof PATHS;

export function I({ name, size = 20, stroke = 1.8 }: { name: IconName; size?: number; stroke?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={name === 'more' ? 3.2 : stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d={PATHS[name]} />
    </svg>
  );
}

export function initials(name: string) {
  const clean = name.replace(/^@/, '').trim();
  const parts = clean.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '·';
}

/** Пастельный фон аватара по имени — чтобы в списке глаз цеплялся за людей */
const AVATAR = [
  ['var(--bc-pink)', 'var(--bc-plum)'],
  ['var(--bc-blue)', 'var(--bc-blue-ink)'],
  ['var(--bc-home)', 'var(--bc-home-ink)'],
  ['var(--bc-learn)', 'var(--bc-learn-ink)'],
  ['var(--bc-docs)', 'var(--bc-docs-ink)'],
  ['var(--bc-perks)', 'var(--bc-perks-ink)'],
] as const;
export function Avatar({ name, id, size }: { name: string; id: string; size?: number }) {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  const [bg, fg] = AVATAR[h % AVATAR.length]!;
  return (
    <span className="bo-avatar" style={{ background: bg, color: fg, ...(size ? { width: size, height: size, fontSize: size * 0.4 } : {}) }} aria-hidden>
      {initials(name)}
    </span>
  );
}

export function PlanBadge({ plan, t }: { plan: 'BAREV_PLUS' | 'ELITE' | null; t: T }) {
  return <span className={`bo-plan bo-plan--${plan ?? 'none'}`}>{plan ? t(`plan.${plan}`) : t('plan.none')}</span>;
}

/** Источник клиента простыми словами */
export function sourceLabel(t: T, c: { source: string; agency?: { name: string } | null; utmSource?: string | null }) {
  if (c.agency) return t('source.agency', { name: c.agency.name });
  if (c.utmSource) return t('source.utm', { name: c.utmSource });
  const key = `source.${c.source}`;
  const tr = t(key);
  return tr === key ? c.source : tr;
}

/** Ключ источника из дашборда: agency:Имя | utm:имя | organic */
export function sourceKeyLabel(t: T, key: string) {
  if (key.startsWith('agency:')) return t('source.agency', { name: key.slice(7) });
  if (key.startsWith('utm:')) return t('source.utm', { name: key.slice(4) });
  return sourceLabel(t, { source: key });
}

/** Модальное окно на <dialog>: фокус, Esc и затемнение — силами браузера */
export function Dialog({ open, onClose, title, children, footer, wide }: { open: boolean; onClose: () => void; title: string; children: ReactNode; footer: ReactNode; wide?: boolean }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={`bo-dialog${wide ? ' bo-dialog--wide' : ''}`}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
      aria-labelledby="bo-dialog-title"
    >
      {open && (
        <div className="bo-dialog__body">
          <h2 id="bo-dialog-title" className="bo-h2">
            {title}
          </h2>
          {children}
          <div className="bo-dialog__foot">{footer}</div>
        </div>
      )}
    </dialog>
  );
}

export function Field({ label, children, hint }: { label: string; children: ReactNode; hint?: ReactNode }) {
  return (
    <label className="bo-field">
      <span className="bo-label">{label}</span>
      {children}
      {hint && <span className="bo-hint">{hint}</span>}
    </label>
  );
}

export function Skeleton({ h }: { h: number }) {
  return <div className="bo-skeleton" style={{ height: h }} aria-hidden />;
}

export function download(filename: string, content: string, type = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const OLD_ADMIN_URL = import.meta.env.VITE_OLD_ADMIN_URL ?? (location.hostname === 'localhost' ? 'http://localhost:5173' : '/');
